import { jsxs as l, jsx as e } from "react/jsx-runtime";
import * as i from "react";
import '../../assets/Alert.css';const s = (r) => /* @__PURE__ */ i.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, ...r }, /* @__PURE__ */ i.createElement("path", { fill: "currentColor", fillOpacity: 0.5, d: "M10 17.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15m-.75-8.25v4.5h1.5v-4.5zm0-3v1.5h1.5v-1.5z" }));
function m({
  variant: r,
  title: n,
  Icon: t,
  children: a,
  className: c = "",
  ...h
}) {
  return /* @__PURE__ */ l("div", { className: `alert alert--${r} ${c}`, ...h, children: [
    t && /* @__PURE__ */ e("span", { children: /* @__PURE__ */ e("span", { children: t }) }),
    /* @__PURE__ */ l("div", { children: [
      /* @__PURE__ */ e("b", { children: n }),
      /* @__PURE__ */ e("div", { children: a })
    ] }),
    /* @__PURE__ */ e(s, {})
  ] });
}
export {
  m as Alert
};
//# sourceMappingURL=Alert.js.map
